function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller, useForm } from 'react-hook-form';
import { ConfirmationModal, TextField } from 'seagull';
import { agreementNameValidation } from "../../business-logic/validators";
import { useStoreActions } from "../../contexts";
import { useUpdateRelationship } from "../../hooks/useUpdateRelationship";
import { agreementChangeModel } from "../../models";
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import styles from "./RenameAgreementModal.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export default function RenameAgreementModal(props) {
  const {
    relationship,
    onSuccess,
    dismissModal
  } = props;
  const {
    control,
    formState,
    handleSubmit
  } = useForm({
    mode: 'all',
    defaultValues: {
      title: relationship.title
    }
  });
  const {
    logBI
  } = useStoreActions();
  const updateRelationship = useUpdateRelationship();
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Rename agreement",
    onCloseButtonClick: dismissModal,
    primaryButtonTestid: "rename-agr",
    primaryButtonDisabled: !formState.isDirty,
    primaryButtonLabel: "Save",
    secondaryButtonLabel: "Cancel",
    onPrimaryButtonClick: handleSubmit(async _ref => {
      let {
        title
      } = _ref;
      updateRelationship(_objectSpread(_objectSpread({}, relationship), {}, {
        changes: [agreementChangeModel.makeTitleChange(title)],
        onSuccess: function (_onSuccess) {
          function onSuccess() {
            return _onSuccess.apply(this, arguments);
          }
          onSuccess.toString = function () {
            return _onSuccess.toString();
          };
          return onSuccess;
        }(() => {
          logBI(14050);
          onSuccess(title);
          dismissModal();
        })
      }));
    }),
    onSecondaryButtonClick: dismissModal,
    content: /*#__PURE__*/_jsx("div", {
      className: styles.content,
      children: /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "title",
        rules: agreementNameValidation,
        render: p => /*#__PURE__*/_jsx(TextField, _objectSpread({
          autoFocus: true,
          testid: "agr-name",
          label: "Agreement name"
        }, connectControllerToTextField(p)))
      })
    })
  });
}